export interface MessageRecipient {
  userId: string;
  displayName: string;
  email?: string | null;
}

export type MessageType = 'internal' | 'external';

export interface ApplicationPostEvent {
  messageId?: number | string;
  messageType: MessageType;
  initiatingUserId: string;
}

/**
 * This is a slimmed down version of Message class,
 * which only contains the Id of the newly created message and its recipients,
 * as the rest of the data is already available on the client side when creating a new message.
 */
export interface MessageInsert {
  id: number;
  recipients?: MessageRecipient[] | null;
}

export class Message {
  body: string;
  fileNames: string[];
  id: number;
  isExternal: boolean;
  senderIsAssignedSpoc: boolean;
  senderIsCurrentUser: boolean;
  senderIsExternalUser: boolean;
  senderIsCustomerOrContractor: boolean;
  senderName: string;
  senderTitle: string;
  senderUserName: string;
  statusChangeId: string;
  statusChangeToId: string;
  statusChangeToName: string;
  timeStamp: string;
  userId?: string;
  statusChangePostTemplate: string;
  fileTypes: string[];
  needsResponse: boolean;
  applicationId: string;
  projectId: string;
  appAddress: string;
  recipients?: MessageRecipient[] | null;
}
